import { Button, Theme } from '@mui/material';
import styled from 'styled-components';

import {
  getSizeStyles,
  getVariantStyles,
} from '@/shared/components/ui/button/common/button-common.styled';
import { TStyledButtonProps } from '@/shared/components/ui/button/common/button-common.types';

export const StyledButton = styled(Button)<TStyledButtonProps>`
  && {
    ${({ theme, $size = 'medium' }) =>
      getSizeStyles(theme as Theme)({ $size })};

    ${({ $variant = 'primary', theme, $clicked }) =>
      getVariantStyles(theme as Theme, $variant)({ $clicked })}

    ${({ $noWrap }) => $noWrap && 'white-space: nowrap;'}

    padding: 0.75rem;
    gap: 0.5rem;
    min-width: unset;
    text-wrap: nowrap;

    &:disabled {
      opacity: 0.28;
    }
  }
`;

export const CircularContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .MuiCircularProgress-root {
    position: absolute;
    transform: translate(-50%, -50%);
  }

  .hidden-label {
    opacity: 0;
  }
`;
